/* eslint-disable jsx-a11y/alt-text */
import React from 'react'
import PropTypes from 'prop-types'
import BaseLibrary from './BaseLibrary'
import { I18n } from 'react-redux-i18n'
import classNames from 'classnames'
import Select from 'react-select'

import styles from './Library.module.scss'
import baseStyles from './BaseLibrary.module.scss'

import Constants from '../../services/constants/Constants'

const svgPath = 'M200,100 C200,44.771525 155.228475,0 100,0 C44.771525,0 0,44.771525 0,100 C0,155.228475' +
  ' 44.771525,200 100,200 C155.228475,200 200,155.228475 200,100 Z'

class Library extends BaseLibrary {

  constructor() {
    super()
    this._bind(
      '_handleDragStart',
      '_handleDragEnd',
      '_renderSearchMedia',
      '_closeOpenLib',
      '_getTagsOptions',
      '_getTagsValue',
      '_renderFAB')
    this.state = {
      isAtLeft: true,
      gridView: false,
      categoryOnly: false,
      openedAlert: false,
      showUnused: true,
      showUsed: true,
      sort: 'creation:DESC',
      search: '',
    }
  }
  componentDidUpdate(prevProps, prevState) {
    if ((prevProps.selectedMediaTags &&
      prevProps.selectedMediaTags.length !== this.props.selectedMediaTags.length &&
      this.props.app) ||
      (!prevProps.opened && this.props.opened)) {
      let tags = this._getTagQuery()
      this.props.fetchMedias(this.props.app.id, this.props.libMediaTypes, this.props.mediasSize, tags)
    }
  }

  _handleDragStart(event) {
    if (document.querySelector('label[for=icon] div')) {
      document.querySelector('label[for=icon] div').style.backgroundColor = '#272a33'
      document.querySelector('label[for=icon] div').style.border = '2px solid #272a33'
    }
    if (document.querySelector('label[for=splash] div')) {
      document.querySelector('label[for=splash] div').style.backgroundColor = '#272a33'
      document.querySelector('label[for=splash] div').style.border = '2px solid #272a33'
    }
    if (document.querySelector('label[for=iconNotif] div')) {
      document.querySelector('label[for=iconNotif] div').style.backgroundColor = '#272a33'
      document.querySelector('label[for=iconNotif] div').style.border = '2px solid #272a33'
    }
    if (document.querySelector('#contentImageDroppable')) {
      document.querySelector('#contentImageDroppable').style.display = 'block'
    }
  }

  _handleDragEnd(event) {
    if (document.querySelector('label[for=icon] div')) {
      document.querySelector('label[for=icon] div').style.backgroundColor = '#fff'
      document.querySelector('label[for=icon] div').style.border = '2px solid #ccc'
    }
    if (document.querySelector('label[for=splash] div')) {
      document.querySelector('label[for=splash] div').style.backgroundColor = '#fff'
      document.querySelector('label[for=splash] div').style.border = '2px solid #ccc'
    }
    if (document.querySelector('label[for=iconNotif] div')) {
      document.querySelector('label[for=iconNotif] div').style.backgroundColor = '#fff'
      document.querySelector('label[for=iconNotif] div').style.border = '2px solid #ccc'
    }
    if (document.querySelector('#contentImageDroppable')) {
      document.querySelector('#contentImageDroppable').style.display = 'none'
    }
  }

  _getTagsOptions(props) {
    let options = []
    if (props.tags && this.state.search.length > 2) {
      options = props.tags.filter(tag => tag.keyword.toLowerCase()
        .includes(this.state.search.toLowerCase()))
        .map(tag => { return { value: tag.id, label: tag.keyword } })
    }

    if (props.searchedTags) {
      props.searchedTags.forEach(tag => {
        let tmpOptions = options.filter(option => option.value === tag.id)
        if (tmpOptions.length === 0) {
          props.tags.filter(tagFromAll => tagFromAll.id === tag.id).forEach(foundedTag => {
            options.push({ value: foundedTag.id, label: foundedTag.keyword })
          })
        }
      })
    }

    return options
  }

  _getTagsValue(props) {
    let value = ''
    if (props.searchedTags) {
      props.searchedTags.map((tag, index) => {
        value = value + tag.id
        if (index < (props.searchedTags.length - 1)) {
          value = value + ','
        }
        return null
      })
    }
    return value
  }

  _renderSearchMedia(icon, index, category) {
    let mediaClassList = classNames(baseStyles.media, baseStyles.iconContainer)
    let entryPoint = this.props.searchMediaEntryPoint ? Constants.UrlsConstants.urlServer +
      this.props.searchMediaEntryPoint
      : Constants.UrlsConstants.urlServer + Constants.UrlsConstants.iconDetailEntryPoint
    let mediaURL = entryPoint + icon + Constants.UrlsConstants.authTokenParam
    return <div
      key={index}
      className={mediaClassList}
      draggable
      data-icon={icon}
      data-category={category}>
      <img
        src={mediaURL}
        data-icon={icon}
        data-category={category}
        onDragStart={this.props.onSearchMediaDragStart}
        onDragEnd={this._handleDragEnd}

      />
    </div>
  }

  _closeOpenLib() {
    this.props.close('user', ['IMAGE', 'PDF'])
  }

  render() {
    let libraryClassList = classNames(styles.library, this.props.opened ? styles.opened : null,
      this.state.isAtLeft ? null : styles.right,
      this.props.appEditorOpened ? styles.blurred : null,
      this.props.libFrom === 'right' ? styles.right : null,
      this.props.libType === 'icons' ? baseStyles.icons : null,
      this.props.libType === 'icons' && this.state.categoryOnly ? baseStyles.categoryOnly : null)

    let mediasLibClassList = classNames(baseStyles.medias,
      baseStyles.modal, this.state.gridView ? '' : baseStyles.listView,
      this.props.showFAB ? baseStyles.fab : null)

    return (
      <div className={this.props.libFrom === 'none' ? styles.none : null}>
        <div id='Library' className={libraryClassList}>
          <div id='LibraryHeader' className={baseStyles.header}>
            <div className={baseStyles.title}>{this.props.title ? this.props.title : I18n.t('Library.title')}</div>
            {this._renderViewChanger()}
            <div className={styles.close} onClick={this.props.close}></div>
          </div>
          {this.props.libType === 'user' ? this._renderProgressSizeBar(this.props.totalSize) : null}
          {this.props.libType === 'user' ? this._renderFilterToolbar('lib') : null}
          {this.props.libType === 'user' ? this._renderFilterTags() : null}
          {this.props.libType === 'icons'
            ? <div className={styles.selectLibrary}>
              <Select
                name='group'
                multi
                options={this._getTagsOptions(this.props)}
                tabIndex='-1' disabled={!this.props.opened}
                placeholder={this.props.placeholderSearch
                  ? this.props.placeholderSearch
                  : I18n.t('select.placeholderIcon')
                }
                noResultsText={I18n.t('select.noResult')}
                value={this._getTagsValue(this.props)}
                onChange={this.props.onChangeTags}
                onInputChange={search => this.setState({ search })}
              />
            </div>
            : null
          }
          <div id='ScrollLibrary' className={mediasLibClassList}>
            <div className={styles.buttonWrapper}>
              {this.props.libType === 'user'
                ? this._renderUploader()
                : null}
              {this.props.libType === 'user'
                ? this._renderMediasUploader()
                : null}
              {this.props.libType === 'user'
                ? this._renderAllMediasDownloader()
                : null}
            </div>

            {/* {this.props.libType === 'user'
              ? this.props.droppedFiles.map((media, index) => {
                return this._renderMediaCheckPreview(media, index, true, this.props)
              }) : null} */}
            {this.props.libType === 'user'
              ? this._filterAndSortMedia(this.props.userMedias).map((media, index) => {
                return this._renderMediaCheckPreview(media, index, true, this.props)
              }) : null}
            {this.props.libType === 'icons'
              ? <div>
                {this.props.searchMedias.map((searchMedia, index) => {
                  return this._renderSearchMedia(searchMedia, index, this._getTagsValue(this.props))
                })}
              </div>
              : null
            }
          </div>
        </div>
        {this._renderDeleteAlert()}
        {this._renderSizeAlert()}
        {this._renderReplaceAlert()}
        {this.props.showFAB ? this._renderFAB() : null}
      </div>
    )
  }

  _renderFAB() {
    let FABClassList = classNames(styles.floatingButton, this.props.currentApp.id ? null : styles.hidden,
      this.props.appEditorOpened ? styles.blurred : null)
    return (<div>
      <div id='FAB' className={FABClassList} onClick={this._closeOpenLib}>
        {this.props.showLoader ? <div className={styles.loader}>Loading</div> : null}
        <svg viewBox='-10 -10 220 220'>
          <g fill='none' strokeWidth='10' transform='translate(100,100)'>
            <path d='M 0,-100 A 100,100 0 0,1 86.6,-50' stroke='url(#cl1)' />
            <path d='M 86.6,-50 A 100,100 0 0,1 86.6,50' stroke='url(#cl2)' />
            <path d='M 86.6,50 A 100,100 0 0,1 0,100' stroke='url(#cl3)' />
            <path d='M 0,100 A 100,100 0 0,1 -86.6,50' stroke='url(#cl4)' />
            <path d='M -86.6,50 A 100,100 0 0,1 -86.6,-50' stroke='url(#cl5)' />
            <path d='M -86.6,-50 A 100,100 0 0,1 0,-100' stroke='url(#cl6)' />
          </g>
        </svg>
        <svg viewBox='-10 -10 220 220'>
          <path d={svgPath} strokeDashoffset='630'></path>
        </svg>
      </div>

      <svg width='0' height='0' style={{ display: 'none' }}>
        <defs>
          <linearGradient id='cl1' gradientUnits='objectBoundingBox' x1='0' y1='0' x2='1' y2='1'>
            <stop stopColor='#fff' />
            <stop offset='100%' stopColor='#fff' />
          </linearGradient>
          <linearGradient id='cl2' gradientUnits='objectBoundingBox' x1='0' y1='0' x2='0' y2='1'>
            <stop stopColor='#fff' />
            <stop offset='100%' stopColor='#fff' />
          </linearGradient>
          <linearGradient id='cl3' gradientUnits='objectBoundingBox' x1='1' y1='0' x2='0' y2='1'>
            <stop stopColor='#fff' />
            <stop offset='100%' stopColor='#fff' />
          </linearGradient>
          <linearGradient id='cl4' gradientUnits='objectBoundingBox' x1='1' y1='1' x2='0' y2='0'>
            <stop stopColor='#fff' />
            <stop offset='100%' stopColor='#fff' />
          </linearGradient>
          <linearGradient id='cl5' gradientUnits='objectBoundingBox' x1='0' y1='1' x2='0' y2='0'>
            <stop stopColor='#fff' />
            <stop offset='100%' stopColor='#fff' />
          </linearGradient>
          <linearGradient id='cl6' gradientUnits='objectBoundingBox' x1='0' y1='1' x2='1' y2='0'>
            <stop stopColor='#fff' />
            <stop offset='100%' stopColor='#fff' />
          </linearGradient>
        </defs>
      </svg></div>)
  }

}

Library.propTypes = {
  opened: PropTypes.bool,
  title: PropTypes.string,
  placeholderSearch: PropTypes.string,
  close: PropTypes.func.isRequired,
  libFrom: PropTypes.string.isRequired,
  userMedias: PropTypes.array,
  droppedFiles: PropTypes.array,
  currentApp: PropTypes.object.isRequired,
  manageFileDrop: PropTypes.func,
  libType: PropTypes.string.isRequired,
  searchMedias: PropTypes.array.isRequired,
  searchMediaEntryPoint: PropTypes.string,
  onRemoveFile: PropTypes.func,
  onSearchMediaDragStart: PropTypes.func,
  showLoader: PropTypes.bool,
  tags: PropTypes.array.isRequired,
  onChangeTags: PropTypes.func.isRequired,
  searchedTags: PropTypes.array.isRequired,
  showFAB: PropTypes.bool.isRequired,
}

export default Library
